import { ProcessingBadge } from '@saas-pages/shared/public/app-shell'
import { useT } from './I18nProvider'

export function LocalizedProcessingBadge() {
  const t = useT()
  return <ProcessingBadge variant="local" label={t.badge.local} title={t.badge.localTitle} />
}
